import dynamic from 'next/dynamic'

import Image from 'next/image'

import Link from 'next/link'

import { v4 as uuidv4 } from 'uuid'

import ImageOptimize from '@/components/ImageOptimize'
import { PageTypeSuffix } from '@/constants'

import { useNotification, useStore } from '@/containers'
import { getTranslate } from '@/utils/api-interceptors'

const OnDevelopPopup = dynamic(() => import('../components/Popup/OnDevelopPopup'), {
  ssr: false
})

const Footer = () => {
  const { bottomMenu, isOpenComingSoon, setIsOpenComingSoon } = useStore()
  const { systemConfig } = useNotification()

  return (
    <footer id='footer' className={`mx-auto w-full bg-white`}>
      <OnDevelopPopup isOpen={isOpenComingSoon} setIsOpen={setIsOpenComingSoon} />

      <section className={`footerInfo border-t-[1px] border-neutral-100 pb-3 pt-14`}>
        <div className={`container mx-auto flex items-end justify-between`}>
          <div className='grid w-full grid-cols-7 gap-4'>
            <div className='aboutUs col-span-2 mb-3 flex w-full flex-wrap gap-2.5'>
              <Link href='/' className='block w-full'>
                <ImageOptimize
                  src={systemConfig?.warehouseLogo || ''}
                  alt={'Điện máy kho'}
                  className='h-auto w-auto max-w-[55%]'
                />
              </Link>
              <div className='flex w-full'>
                <div className='max-w-[20x] flex-[0_0_20px]'>
                  <Image src='/assets/icons/footer/phone.svg' width={20} height={20} alt='phone' />
                </div>
                <div className='flex-1 pl-2'>
                  <p>Tổng đài mua hàng:</p>
                  {systemConfig?.warehousePhone && (
                    <div className='w-full'>
                      <p className='text-base font-bold leading-tight text-dark-900'>{systemConfig?.warehousePhone}</p>
                      <p className='text-sm italic text-gray-800'>{systemConfig?.warehouseLabelPhone}</p>
                    </div>
                  )}
                </div>
              </div>
              <div className='flex w-full'>
                <div className='max-w-[20x] flex-[0_0_20px]'>
                  <Image src='/assets/icons/footer/email.svg' width={20} height={20} className='pt-1.5' alt='phone' />
                </div>
                <div className='flex-1 pl-2'>
                  <Link href={'mailto:cskh@dienmaykho.com'} className='text-sm font-medium italic leading-tight'>
                    cskh@dienmaykho.com
                  </Link>
                </div>
              </div>
              <div className='flex w-full'>
                <div className='max-w-[20x] flex-[0_0_20px]'>
                  <Image src='/assets/icons/footer/address.svg' width={20} height={20} alt='phone' />
                </div>
                <div className='flex-1 pl-2'>
                  <p className='text-sm font-medium italic leading-tight'>
                    Ngõ 908 Kim Giang, Thanh Liệt, Thanh Trì, Hà Nội
                  </p>
                </div>
              </div>
            </div>
            <div className='col-span-5'>
              <div className='grid w-full grid-cols-4 gap-5'>
                {bottomMenu &&
                  bottomMenu.length > 0 &&
                  bottomMenu.map(e => (
                    <div className='w-full' key={uuidv4()}>
                      <h5 className='mb-3 text-fieldLabel font-bold text-black-100'>{getTranslate(e.name)}</h5>
                      {e.children && e.children.length > 0 && (
                        <ul>
                          {e.children.map(f => (
                            <li key={uuidv4()} className='mb-[4px] flex items-start font-medium'>
                              {f.type === 'link' ? (
                                <a href={`${f.url}` || ''}>{getTranslate(f.name)}</a>
                              ) : (
                                <a href={`/${f.slug + PageTypeSuffix.PAGE_CMS}` || ''}>{getTranslate(f.name)}</a>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={`footerInfo bg-white-500 py-2`}>
        <div className={`container mx-auto flex items-center justify-between`}>
          <ul className='flex items-center justify-end gap-2'>
            {systemConfig?.warehouseFacebook && (
              <li className=''>
                <Link
                  href={systemConfig?.warehouseFacebook || '/'}
                  target='blank'
                  className='flex h-[30px] w-[30px] items-center justify-center rounded-full bg-primary-base'
                >
                  <img src='/assets/icons/social/facebook.svg' alt='Facebook' className='h-[30px] w-[30px]' />
                </Link>
              </li>
            )}
            {systemConfig?.warehouseYoutube && (
              <li className=''>
                <Link
                  href={systemConfig?.warehouseYoutube || '/'}
                  target='blank'
                  className='flex h-[30px] w-[30px] items-center justify-center rounded-full bg-primary-base'
                >
                  <img src='/assets/icons/social/youtube.svg' alt='Youtube' className='h-[30px] w-[30px]' />
                </Link>
              </li>
            )}
            {systemConfig?.warehouseInstagram && (
              <li className=''>
                <Link
                  href={systemConfig?.warehouseInstagram || '/'}
                  className='flex h-[30px] w-[30px] items-center justify-center rounded-full bg-primary-base'
                  target='blank'
                >
                  <img src='/assets/icons/social/instagram.svg' alt='Instagram' className='h-[30px] w-[30px]' />
                </Link>
              </li>
            )}
            {systemConfig?.warehouseTikTok && (
              <li className=''>
                <Link
                  href={systemConfig?.warehouseTikTok || '/'}
                  target='blank'
                  className='flex h-[30px] w-[30px] items-center justify-center rounded-full bg-primary-base'
                >
                  <img src='/assets/icons/social/tiktok.svg' alt='Tiktok' className='h-[30px] w-[30px]' />
                </Link>
              </li>
            )}
          </ul>
          <p className='text-sm font-medium text-gray-800'>
            {/* {getTranslate(systemConfig?.companyLicense)} */}© 2025 DIENMAYKHO. All rights reserved
          </p>
        </div>
      </section>
    </footer>
  )
}

export { Footer }
